import React, { FC, memo } from 'react';
import { useParams } from 'react-router-dom';
import { useGetSizeCodesByWarehouseIdQuery } from 'entities/SizeCode';
import { Point } from '../../../utils/helpers/coordinates';
import { BoxesList } from './BoxesList';

interface BoxPickerProps {
  floorId: string;
  getDropPoint: () => Point;
}

export const BoxPicker: FC<BoxPickerProps> = memo((props) => {
  const { floorId, getDropPoint } = props;

  const { warehouseId } = useParams();

  const { data } = useGetSizeCodesByWarehouseIdQuery(warehouseId, { skip: !warehouseId });

  return (
    <BoxesList warehouseId={warehouseId} floorId={floorId} getDropPoint={getDropPoint} hasAvailableSizeCodes={Boolean(data?.length)} />
  );
});
